import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface DeleteTodoModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
}

export const DeleteTodoModal: React.FC<DeleteTodoModalProps> = ({
    show,
    onHide,
    onConfirm
}) => {
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Radera uppgift</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Är du säker på att du vill radera denna uppgift?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Avbryt
                </Button>
                <Button variant="danger" onClick={onConfirm}>
                    Radera
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
